module.exports = __webpack_public_path__ + "static/media/banner-sample-02.e778b042.jpg";